<div class="mat-typography app-frame mat-app-background">
    <app-huna-container-outPage [currentUrl]="currentUrl" [showSidenav]="isLogged()&&(showSidenav$|async)"
                                [isTest]="isConnectToProd">
        <router-outlet>

        </router-outlet>
    </app-huna-container-outPage>
</div>